import type { ChatAttachmentMeta } from '../../lib/chat';

export function humanSize(bytes: number): string {
  if (!bytes || bytes < 1024) return `${bytes || 0} B`;
  const units = ['KB', 'MB', 'GB'];
  let n = bytes / 1024;
  let i = 0;
  while (n >= 1024 && i < units.length - 1) {
    n /= 1024;
    i++;
  }
  return `${n.toFixed(n < 10 ? 1 : 0)} ${units[i]}`;
}

export function isPdf(meta: ChatAttachmentMeta): boolean {
  return meta.mime === 'application/pdf' || /\.pdf$/i.test(meta.filename);
}
